import { gql } from "@apollo/client";
import apolloClient from "../graphql";
import {
  ADD_PASSENGER_CONTACT,
  BOOKING_COMMIT1,
  PASSENGER_CONTACT_INFANT_UPDATE,
  UPDATE_PASSENGER_DOB,
  UPDATE_PRIMARY_CONTACT_DETAILS
} from "../graphql/mutation";

export async function passengerContactAndInfantUpdate(params: any) {
  const response = await apolloClient
    .mutate({
      mutation: PASSENGER_CONTACT_INFANT_UPDATE,
      variables: {
        contactTypeCode: "P",
        request: {
          ...params
        }
      }
    })
    .catch((err) => console.warn(err));
  return response;
}

export async function addPassengerContact(params: any) {
  const response = await apolloClient
    .mutate({
      mutation: ADD_PASSENGER_CONTACT,
      variables: {
        request: {
          ...params,
          contactTypeCode: "O"
        }
      }
    })
    .catch((err) => console.warn(err));
  return response;
}

export async function updatePrimaryContactDetails(params: any) {
  const response = await apolloClient
    .mutate({
      mutation: UPDATE_PRIMARY_CONTACT_DETAILS,
      variables: {
        contactTypeCode: "P",
        request: {
          ...params
        }
      }
    })
    .catch((err) => console.warn(err));
  return response;
}

export async function commitContactChanges(recordLocator: any) {
  const response = await apolloClient
    .mutate({
      mutation: BOOKING_COMMIT1,
      variables: {
        recordLocator
      }
    })
    .catch((err) => console.warn(err));
  return response;
}

export async function addDateOfBirth(params: any) {
  const response = await apolloClient
    .mutate({
      mutation: UPDATE_PASSENGER_DOB,
      variables: params
    })
    .catch((err) => console.warn(err));
  return response;
}

export async function addEmergencyContactDetails(selectedPassengers: any, emergencyContactDetails: any) {
  try {
    let addEmergencyContactDetailsMutation = "";
    selectedPassengers.forEach((item, index) => {
      addEmergencyContactDetailsMutation += `
        address${index}: passengerAddressAddv2(
          passengerKey: "${item.passengerKey}"
          request: {
            status: Emergency,
            companyName: "${emergencyContactDetails?.name || ""}",
            countryCode: "${emergencyContactDetails?.selectCountry || ""}",
            lineOne: "${emergencyContactDetails?.relationship || ""}",
            phone: "${emergencyContactDetails?.phoneNumber || ""}"
          }
        ) {
          passengerAddressKey
        }`;
    });

    const mutation1 = gql`mutation updateEmergencyContact{
      ${addEmergencyContactDetailsMutation}
    }`;

    const response = await apolloClient.mutate({
      mutation: mutation1,
      variables: {}
    });

    return response;
  } catch (error) {
    console.warn(error);
  }
}

export async function updateEmergencyContactDetails(
  selectedPassengers: any,
  emergencyContactDetails: any,
  passengersAddressKey: any
) {
  try {
    let addEmergencyContactDetailsMutation = "";

    selectedPassengers.forEach((item, index) => {
      addEmergencyContactDetailsMutation += `
        address${index}: passengerAddressSetv2(
          passengerKey: "${item.passengerKey}"
          addressKey: "${passengersAddressKey}"
          request: {
            companyName: "${emergencyContactDetails?.name || ""}",
            countryCode: "${emergencyContactDetails?.selectCountry || ""}",
            lineOne: "${emergencyContactDetails?.relationship || ""}",
            phone: "${emergencyContactDetails?.phoneNumber || ""}"
          }
        ) {
          passengerAddressKey
        }`;
    });

    const mutation1 = gql`mutation updateEmergencyContact {
      ${addEmergencyContactDetailsMutation}
    }`;

    const response = await apolloClient.mutate({
      mutation: mutation1,
      variables: {}
    });

    return response;
  } catch (error) {
    console.warn(error);
  }
}